module.exports = __webpack_public_path__ + "img/35a41aa2e6f76b5212c0e6007bde6b1b.png";